import { z } from "zod";

import { COLON } from "./str";

const zUrlScheme = z.enum(["EMAIL", "PHONE"]);
const UrlScheme = zUrlScheme.Enum;
type UrlScheme = z.infer<typeof zUrlScheme>;

const PrefixByScheme: Record<UrlScheme, string> = {
  EMAIL: "mailto",
  PHONE: "tel",
};

function customizeHref(scheme: UrlScheme, value: string) {
  return [PrefixByScheme[scheme], value].join(COLON);
}

export { customizeHref, UrlScheme };
